// Auto-generated normalizer for table: GENERAL.Empresas
export function empresasNormalize(row) {
  return {
    idEmpresa: row.idEmpresa ?? row.IdEmpresa ?? row["idEmpresa"] ?? row["IdEmpresa"] ?? 0,
    nombre: row.nombre ?? row.Nombre ?? row["nombre"] ?? row["Nombre"] ?? "",
    idPadre: row.idPadre ?? row.IdPadre ?? row["idPadre"] ?? row["IdPadre"] ?? null,
    activo: row.activo ?? row.Activo ?? row["activo"] ?? row["Activo"] ?? true,
  };
}
